// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1qL4K","col":"Table_col__2uO1w","fulfillmentStatus":"Table_fulfillmentStatus__27elg","emailCol":"Table_emailCol__QekZ0"};